











import { namespace } from 'vuex-class'
import { Vue, Component, Emit } from 'vue-property-decorator'
import BidProcedureDetailLayout from '@/UI/UserProcedures/BidProcedures/BidProcedureDetailLayout.vue'
import { ProcedureId } from '@/Domain/Procedures'
import { ProcedureDto } from '@/Application/Procedures'
import { BatchDto, ProcedureBatchesDto } from '@/Application/Batch'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import {
  FetchProcedureByUserCommandHandlerProvider
} from '@/Infrastructure/Procedures/Provider/FetchProcedureByUserCommandHandlerProvider'
import { FetchProcedureByUserCommand } from '@/Application/Procedures/FetchProcedureByUserCommand'
import { AccountId } from '@/Domain/Account/AccountId'

const procedureStore = namespace('procedure')
@Component({
  components: { BidProcedureDetailLayout }
})
export default class BidProcedureDetail extends Vue {
  procedure: ProcedureDto | null = null
  riscoBatches: BatchDto[] = []
  resultasBatches: BatchDto[] = []
  errorLoading = false

  @procedureStore.Getter
  public currentProcedure!: ProcedureDto

  @procedureStore.Action
  public setCurrentProcedure!: (procedureDto: ProcedureDto) => void

  @procedureStore.Action
  public setProcedureBatches!: (payload: { risco: BatchDto[]; resultas: BatchDto[] }) => void

  public mounted (): void {
    this.loadData()
  }

  public loadData (): Promise<void> {
    this.errorLoading = false
    EventBus.$emit('loading', true)
    const procedureId = new ProcedureId(this.$route.params.procedureId)
    return this.loadBatches(procedureId)
      .then((response: ProcedureBatchesDto) => {
        this.procedure = response.procedure
        this.resultasBatches = response.batches.RESUL
        this.riscoBatches = response.batches.RISCO
      })
      .catch(() => {
        this.errorLoading = true
      })
      .finally(() => {
        EventBus.$emit('loading', false)
      })
  }

  public loadBatches (procedureId: ProcedureId): Promise<ProcedureBatchesDto> {
    const accountId = new AccountId('A32574188')
    const provider = new FetchProcedureByUserCommandHandlerProvider()
    const command = new FetchProcedureByUserCommand(accountId, procedureId)
    const handler = provider.provide()
    return handler.handle(command)
  }

  @Emit()
  onProcedureSelected (): void {
    if (this.procedure !== null) {
      this.setCurrentProcedure(this.procedure)
      this.setProcedureBatches({ risco: this.riscoBatches, resultas: this.resultasBatches })
      this.$router.push({ name: 'Auction', params: { procedureId: this.procedure.procedureId } })
    }
  }
}
